(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Track selected variants per card
  const nnSelectedVariants = {};

  document.addEventListener('click', function(e) {
    // Handle pill selection
    const btn = e.target.closest('.nn-variant-btn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();

      const cardId = btn.dataset.cardId;
      const variantId = btn.dataset.variantId;
      const card = document.getElementById('product-card-' + cardId);
      if (!card) return;

      // Store selected variant for this card
      nnSelectedVariants[cardId] = {
        id: variantId,
        url: btn.dataset.variantUrl,
        price: btn.dataset.variantPrice
      };

      // Update active pill
      card.querySelectorAll('.nn-variant-btn').forEach(b => b.classList.remove('nn-variant-btn--active'));
      btn.classList.add('nn-variant-btn--active');

      // Update card link URL
      const link = card.querySelector('.product-card__link');
      if (link) link.href = btn.dataset.variantUrl;

      // Update price display
      const priceEl = card.querySelector('.price__regular .price');
      if (priceEl) priceEl.textContent = btn.dataset.variantPrice;

      // Update hidden form input
      const variantInput = card.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = variantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      return;
    }

    // Intercept Buy it Now button click
    const buyNow = e.target.closest('shopify-buy-it-now-button button, .shopify-payment-button__button');
    if (buyNow) {
      const card = buyNow.closest('product-card');
      if (!card) return;

      const cardId = card.id.replace('product-card-', '');
      const selected = nnSelectedVariants[cardId];
      if (!selected) return; // No pill selected, let default behaviour run

      e.preventDefault();
      e.stopPropagation();

      // Redirect to variant URL with checkout
      const variantUrl = selected.url.includes('?')
        ? selected.url + '&checkout=true'
        : selected.url;

      // Direct to checkout with selected variant
      fetch('/cart/clear.js', { method: 'POST' })
        .then(() => fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(selected.id), quantity: 1 })
        }))
        .then(() => { window.location.href = '/checkout'; })
        .catch(err => {
          console.warn('Buy it now fallback failed', err);
          window.location.href = selected.url;
        });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
